import React from 'react';
import { Container } from './style';

const AboutHeader = () => (
  <>
    <Container>
      <h3 className="title">SOBRE O SANARFLIX</h3>
      <h2 className="title">Seja bem-vindo ao SanarFlix!</h2>
    </Container>
  </>
);
export default AboutHeader;
